import React, { useState } from "react";
import { Wrapper, Text } from "@networkraildigitalfactory/components";
import styles from "./Admin.module.css";
import useAdminExport from "../../hooks/adminExport/useAdminExport";
import AdminExport from "../AdminExport/AdminExport";
import EmployeeSearchResult from "./EmployeeSearchResult";
import SearchEmployee from "./SearchEmployee";
import PageTitle from "../PageTitle/PageTitle";

const Admin = () => {
  const {
    exportMenu,
    setExport,
    results,
    searchValue,
    searchCriteria,
    setSearchValue,
    search,
    inputError,
    toggleSearch,
  } = useAdminExport();

  const [selectedEmployee, setSelectedEmployee] = useState();

  const paragraph = [
    "You can obtain employee records from iPerform here, including Objectives, 1-2-1s and Performance reviews. \n\nUse the search below to obtain employee records.",
  ];

  return (
    <>
      <Wrapper maxWidth={1375} align="center">
        <PageTitle titleHeader="Employee Search" titleParagraph={paragraph} hideButton></PageTitle>
        <div className={styles.searchContainer}>
          <SearchEmployee
            searchEmp={search}
            criteria={searchCriteria}
            inputError={inputError}
            searchValue={searchValue}
            toggleSearch={toggleSearch}
            setSearchValue={setSearchValue}
          />
        </div>
        <Wrapper maxWidth={700} align="center">
          {results && (
            <>
              <Text
                wrapper="h2"
                type="subtitle"
                color="#37519D"
                style={{ marginTop: "margin-top: 30px" }}
              >
                Search Results
              </Text>
              {results.length === 0 && (
                <div className={styles.searchNoResults}>No results found</div>
              )}
              {results.map((result) => (
                // eslint-disable-next-line
                <EmployeeSearchResult
                  result={result}
                  setExport={setExport}
                  selectedEmployee={selectedEmployee}
                  setSelectedEmployee={setSelectedEmployee}
                />
              ))}

              {results.length > 0 && (
                <>
                  {exportMenu ? (
                    <AdminExport
                      selectedEmployee={selectedEmployee.email}
                      employeeName={selectedEmployee.fullName}
                      employeeNumber={selectedEmployee.empNo}
                    />
                  ) : (
                    <Text style={{ marginTop: "20px", marginLeft: "10px" }}>
                      Once you have confirmed this is the correct employee, you will be able to
                      export objective, pdp, 1-2-1 or performance review data.
                    </Text>
                  )}
                </>
              )}
            </>
          )}
        </Wrapper>
      </Wrapper>
    </>
  );
};

export default Admin;
